import filmArchiveRoutes from "./digibord/archive/film-archive-routes";
import musicArchiveRoutes from "./digibord/archive/music-archive-routes";

import calendarRoutes from "./digibord/season/calendar-routes";
import filmRoutes from "./digibord/season/film-routes";
import musicRoutes from "./digibord/season/music-routes";
import materialRoutes from "./digibord/season/material-routes";
import extraRoutes from "./digibord/season/extra-routes";

import SectionMenu from "../../views/digibord/SectionMenu.vue";
import SchoolLevelMenu from "../../views/digibord/SchoolLevelMenu.vue";
import DigibordContent from "../../views/digibord/DigibordContent.vue";

export default [
  {
    path: "/:volumeSlug/:schoolLevelSlug/",
    name: "Digibord",
    components: {
      sectionNavigation: SectionMenu,
      schoolLevelNavigation: SchoolLevelMenu,
      content: DigibordContent,
    },
    children: [
      // Archive routes
      ...filmArchiveRoutes,
      ...musicArchiveRoutes,

      // Season routes
      ...calendarRoutes,
      ...filmRoutes,
      ...musicRoutes,
      ...materialRoutes,
      ...extraRoutes,
    ],
  },
];
